// Dependencies
require("webstrap/type");
require("grid");

// Element
require("element/information");
require("element/information-small");

// Styles
require("./information.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/information/index.js
 ** module id = 148
 ** module chunks = 0 1
 **/